
const resourcetemplate = res => {
  
  const thumb = res.coverurl ?
  res.coverurl
  :
  '/wp-content/themes/academy-theme/assets/images/placeholder.png'

  const terms = '' 
  const termstitles = res.terms ?
  '<div <div class="Terms">' +
  Object.values(res.terms)
  .map(t => `<span class="Term">${ t }</span>`)
  .join(', ') + 
  '</div>'
  :
  ''

  return `<div class="Resource">
    <div class="Cover">
      <div 
        class="Image"
        style="background-image: url(${ thumb });"
      >
      </div>
    </div>
    <div class="Data">
      <div class="TitleTermsExcerptWrapper">
        <div 
          class="TitleTermsExcerpt" 
          style="top: 0px;"
        >
          <div class="Title">
            ${ res.title }
          </div>
          ${ termstitles }
          <div class="Excerpt">
            ${ res.description }          
          </div>
        </div>
      </div>
    </div>
    <div class="Tools">
      <button 
        class="wp-block-search__button wp-element-button Preview"
        href="${ res.resourceurl }"
        title="${ res.title }"
      >
        Preview
      </button>
      <button 
        class="wp-block-search__button wp-element-button Download"
        href="${ res.resourceurl }"
        title="${ res.title }"
      >
        Download
      </button>
    </div>
  </div>`
}

(function($) {

  const ispartnersupport = $('body').hasClass('single-partnersupportarea')
  if(ispartnersupport) {

    $('.ast-header-search').remove()

  } else {

    $('.ast-header-search').show()
  }

  const renderlist = (term, text) => {

    let resourceshtml = partner_support_resources
    .filter(r => {

      return (
        (!term || r.terms?.[term + ''] !== undefined) 
        &&
        (!text || r.title.includes(text) || r.description?.includes(text))      
      )
    })
    .map(r => resourcetemplate(r))

    const headerhtml = `<div class="ResourcesCategory">
      ${ 
        term ? 
        '<span>' + partner_support_categories[term].name + '</span>'
        : 
        '<span>All</span> Categories' 
      }
      ${
        text ?
        ' & search <span>' + text + '</span>'
        :
        ''
      }
      (<span>${ resourceshtml.length }</span>)
    </div>`

    resourceshtml = resourceshtml.length ?
    resourceshtml.join('')
    :
    '<div ="NoResources">There is no resources for this category</div>'

    return headerhtml + 
    '<div class="List">' + 
      resourceshtml + 
    '</div>'
  }

  const $partnersupportresourcecategories= $('.PartnerSupportResourceCategories')
  const $categories = $partnersupportresourcecategories.find('.Category')
  const $partnersupportresources = $('.PartnerSupportResources')

  let selectedterm = ''

  window.selectPartnerSupportResourceList = (term) => {

    if(term == 0) {

      selectedterm = ''
    }

    const searchtext = $partnersupportformsearchtextinput.val()
    selectedterm = term || selectedterm

    let $categoryclicked
    if(!selectedterm) {

      $categoryclicked = $partnersupportresourcecategories
      .find('#PSC_All')

    } else {

      $categoryclicked = $partnersupportresourcecategories
      .find('#PSC_' + selectedterm)
    }

    $categories.removeClass('Selected')

    if($categoryclicked.hasClass('HasChildren')) {

      if($categoryclicked.hasClass('Open')) {

        $categoryclicked.removeClass('Open')

      } else {

        $categoryclicked.addClass('Open')
      }

      return 
    }

    $categoryclicked
    .addClass('Selected')
    .parents('.Category')
    .addClass('Open')
    
    $partnersupportresources.fadeOut(
      300,
      function() {

        $partnersupportresources.html(renderlist(selectedterm, searchtext))

        $partnersupportresources.find('button.wp-block-search__button.wp-element-button')
        .on(
          'click',
          function() {

            const $this = $(this)
            const href = $this.attr('href')
            const title = $this.attr('title')

            if($this.hasClass('Download')) {                

              const link = document.createElement('a');
              link.href = href;
              link.download = title;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }

            if($this.hasClass('Preview')) {

              window.open(href, title);
            }
          }
        )

        $partnersupportresources.fadeIn(300)

        $partnersupportresources.find('.List .Resource .Data .TitleTermsExcerptWrapper')
        .on(
          'mouseenter',
          function() {

            const $wrapper = $(this)
            const wrapperheight = $wrapper.height()
            const $titleexcerpt = $wrapper.find('.TitleTermsExcerpt')
            const titleexcerptheight = $titleexcerpt.height();
            const scroll = wrapperheight - titleexcerptheight - 20
            
            if(scroll < 0) {
              
              $titleexcerpt.css('top', scroll + 'px')
            }
          }
        )
        .on(
          'mouseleave',
          function() {

            const $wrapper = $(this)
            const $titleexcerpt = $wrapper.find('.TitleTermsExcerpt')

            $titleexcerpt.css('top', '0px')
          }
        )
      }
    )      
  }

  const $partnersupportformsearchtext = $('form.PartnerSupportSearchText')
  const $partnersupportformsearchtextinput = $partnersupportformsearchtext.find('input.wp-block-search__input')

  $partnersupportformsearchtext
  .on(
    'submit',
    function(e) {

      e.preventDefault();

      window.selectPartnerSupportResourceList()

      return false
    }
  )

  $partnersupportformsearchtextinput
  .on(
    'blur',
    function() {

      const $this = $(this)

      if($this.val().trim() == '') {
        
        $this.val('')
        window.selectPartnerSupportResourceList()
      }
    }
  )

  window.selectPartnerSupportResourceList()  

})(jQuery)